import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';

import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';

import { MatCheckboxModule } from '@angular/material/checkbox';

import { DocumentFormAutoCompleteModule } from '../../chipList/Document/Document.module';

import { DocumentTypeFormAutoCompleteModule } from '../../chipList/DocumentType/DocumentType.module';

import { ParametreDocumentFormComponent } from './ParametreDocument.component';

@NgModule({
  declarations: [ParametreDocumentFormComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,

    MatInputModule,
    MatSelectModule,

    MatCheckboxModule,

    DocumentFormAutoCompleteModule,

    DocumentTypeFormAutoCompleteModule
  ],
  exports: [
    ParametreDocumentFormComponent,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,

    MatInputModule,
    MatSelectModule,

    MatCheckboxModule,

    DocumentFormAutoCompleteModule,

    DocumentTypeFormAutoCompleteModule
  ]
})
export class ParametreDocumentFormModule {}
